import { Component, Input, OnInit } from "@angular/core";
import { ImageViewerService } from "ng/src/app/core/image-viewer/image-viewer.service";
import { PreviewViewerService } from "ng/src/app/core/preview-viewer/preview-viewer.service";
import { FileAttachment, FileAttachmentRowData } from "ng/src/app/notes/shared/file-attachments/file-attachment.model";
import { FileDetailType } from "ng/src/app/files/file-details/file-details.model";

@Component({
	template: `
		<div class="p-d-flex p-ai-center p-jc-start file-entry-listing" style="overflow: auto">
	        <a [title]="usePreview ? 'Preview File' : 'Go to file details'" href="/#/files?fileId={{file.id}}">
				<span class="p-d-flex p-ai-center" (click)="previewFile($event)">
			        <span *ngIf="showIcon && usePreview && (!showImageThumbnail || !isImage)" class="pi {{icon}} p-mr-2"></span>
					<span class="p-d-flex p-flex-column p-jc-center">
						<img *ngIf="isImage && showImageThumbnail" src="{{getHref(file)}}?thumbnail=true" [alt]="file.filename"
			                 class="clickable p-m-auto">
			                {{file.filename}}
					</span>
				</span>
	        </a>
		</div>
	`,
	selector: 'lb-file-detail-listing[file]'
})
export class FileDetailListingComponent implements OnInit {
	@Input() file!: FileAttachment;
	@Input() showImageThumbnail = true;
	@Input() siblings: FileAttachment[] = [];
	@Input() usePreview = true;
	@Input() showIcon = true;
	
	getHref = FileAttachment.getHref;
	
	isImage = false;
	icon: string = '';
	canPreview = false;
	
	constructor(
		private imageService: ImageViewerService,
		private viewerService: PreviewViewerService
	) {}
	
	ngOnInit(): void {
		this.icon = PreviewViewerService.getPreviewIcon(FileDetailType.getType(this.file.contentType ?? ''));
		this.isImage = FileAttachment.isImage(this.file);
		this.canPreview = PreviewViewerService.canPreviewFile(this.file);
	}
	
	previewFile(event: MouseEvent) {
		if (!this.usePreview || event.metaKey || event.ctrlKey) {
			return;
		}
		else if (this.isImage) {
			event.preventDefault();
			const row = FileAttachmentRowData.fromFileAttachment(this.file);
			const rowData = FileAttachmentRowData.fromFileAttachments(this.siblings);
			const idx = rowData.findIndex(rd => rd.id === row.id);
			
			rowData.splice(idx === -1 ? 0 : idx, idx > -1 ? 1 : 0, row);
			
			this.imageService.showImageViewer(this.getHref(this.file), rowData);
		}
		else {
			this.viewerService.previewFileEventHandler(this.file, event);
		}
	}
}